export class FundingForEOSCSums {
  totalFundingForEOSC: string = null;
  fundingToOrganisationsInEOSCA: string = null;
  fundingToOrganisationsOutsideEOSCA: string = null;
  earmarkedContributions: string = null;
  nonEarmarkedContributions: string = null;
  structuralInvestmentFunds: string = null;
}
